import { useTranslation } from 'react-i18next';
import { COLORS } from '../../constants';
import { Link } from '../common/buttons';
import Icon, { iconNames } from '../common/icon';

export const NavbarLink = ({ to, text, icon, isMobile = false, onClose }) => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (isMobile && onClose) {
            onClose();
        }
    };

    return (
        <div style={{ display: 'flex' }}>
            {isMobile && icon && (
                <Icon
                    name={iconNames[icon]}
                    size={24}
                    fill={COLORS.GRAY_LIGHT}
                />
            )}
            <Link
                key={to}
                to={to}
                text={isMobile ? <b>{t(text)}</b> : t(text)}
                className="nav__item url"
                onClick={handleClick}
            />
        </div>
    );
};
